import React from 'react';

export const ArrowLeft = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 44 45"
      {...props}
    >
      <g data-name="Group 1023">
        <g data-name="Group 1022" fill="none">
          <path
            data-name="Rectangle 47-2"
            style={{
              isolation: 'isolate',
            }}
            opacity={0.25}
            d="M0 0h44v45H0z"
          />
          <path
            data-name="Path 4-2"
            d="M25.13 27.76L19.41 22l5.72-5.72"
            stroke="#26375f"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />
        </g>
      </g>
    </svg>
  );
};
